import {
    loadFbacScript,
    initCorporateConcierge,
    initCareersConcierge,
} from "../../fbac-global/js/global.js";

const handleSearchOverlayToggle = () => {
    const btn = document.getElementById("search-btn");
    const serachOverlay = document.querySelector(".search_overlay");
    const header = document.querySelector(".header");

    if (!btn || !serachOverlay) return;

    // 1. Preload FBAC on user intent (hover or keyboard focus)
    const preloadFbac = () => {
        loadFbacScript().catch(() => {});
    };

    btn.addEventListener("pointerenter", preloadFbac, { once: true });
    btn.addEventListener("focusin", preloadFbac, { once: true });

    // 2. Open drawer and initialize autocomplete on click
    btn.addEventListener("click", async () => {
        serachOverlay.setAttribute("style", "display: block;");
        const btnClose = document.getElementById("close-btn");
        if (header) header.classList.add("header_sticky");

        if (btnClose && !btnClose._bound) {
            btnClose.addEventListener("click", () => {
                serachOverlay.setAttribute("style", "display: none;");
                if (header) header.classList.remove("header_sticky");
            });
            btnClose._bound = true;
        }

        try {
            await loadFbacScript();
            if (document.querySelector("#fbac-careers")) {
                initCareersConcierge();
            } else if (document.querySelector("#fbac")) {
                initCorporateConcierge();
            }

            const input = serachOverlay.querySelector("#query");
            if (input) {
                input.focus();
            }
        } catch (err) {
            console.warn("Could not initialize FBAC search autocomplete:", err);
        }
    });
};

export default handleSearchOverlayToggle;
